import { z } from "zod";
import { defineQuery } from "supabase/database/server.ts";
import { DefaultThumbnails } from "./types.ts";

export const getDefaultThumbnails = defineQuery(
  "getDefaultThumbnails",
  {
  input: z.object({}).optional(),
  handler: async ({ db }) => {
    const { data, error } = await db
      .from("default_thumbnails")
      .select("*")
      .limit(1)
      .single();
    if (error) throw error;
    return data as DefaultThumbnails;
  },
});
